import axios from "axios";
import { setStorageValue } from "./localStorage";
import { toast } from "sonner";
import { getSimplifiedError } from ".";

const apibaseUrl = process.env.REACT_APP_BASE_URL;


export const url = {
  login: "login",
  register: "signup/client",
  resend: "email/verify/resend",
  reset: "password/reset",
  verify: "email/verify",
  profile: "profile",
  account_setup: "client/profile",
  banks: "bank/account",
  resolveAccount: "bank/resolve",
  creatorspage: "jollof",
  membership: "jollof/plan",
  supporters: "customer",
  dashboardStats: "jollof/dashboard",
  dashboardEarnings: "jollof/earnings",
  settings: "settings",
};

export let ApiService = axios.create({
  baseURL: apibaseUrl,
});

export const getBanks = () => {
  axios
    .get("https://api.paystack.co/bank")
    .then((res) => {
      const data = res.data.data.map((bank: any) => {
        return {
          ...bank,
          label: bank.name,
          value: bank.name,
        };
      });

      setStorageValue({ key: "bmj_banks", value: data });
    })
    .catch((err) => {
      toast.error("An error occurred while fetching banks");
    });
};

export const verifyAccountNumber = async (payload: any) => {
  try {
    const res = await ApiService.get(url.resolveAccount, {
      params: {
        accountNumber: payload?.accountNumber,
        bankCode: payload?.bankCode,
      },
    });

    const data = res.data.data;
    return data;
  } catch (err) {
    getSimplifiedError(err);
  }
};
